import { render, staticRenderFns } from "./LichessModerationTournament.vue?vue&type=template&id=6e78df0e&lang=pug"
import script from "./LichessModerationTournament.vue?vue&type=script&lang=js"
export * from "./LichessModerationTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports